import React, {useEffect, useState} from 'react';
import JournalEntryComponent from './JournalEntryComponent';
import AddJournalComponent from './AddJournalComponent';
import '../../../css/gardenManagerStylings/journalSection/GardenManagerJournalStyling.css';

const GardenManagerJournalComponent = ({ journals, garden, onRefreshJournals }) => {
    const [currentView, setCurrentView] = useState('entries');
    const [gardenSpecificJournals, setGardenSpecificJournals] = useState([]);
    const [otherJournals, setOtherJournals] = useState([]);

    const handleViewChange = (view) => {
        setCurrentView(view);
    };

    const filterJournalEntries = () => {
        if (!garden || !garden.id) {
            setGardenSpecificJournals([]);
            setOtherJournals(journals);
            return;
        }

        setGardenSpecificJournals(journals.filter(journal => journal.garden_id === garden.id));
        setOtherJournals(journals.filter(journal => journal.garden_id !== garden.id));
    }

    // filter garden journals based on the selected garden, then the rest of the entries if needed!
    useEffect(() => {
        filterJournalEntries();
    }, [garden, journals]); // Added journals as dependency

    const handleJournalRefresh = () => {
        onRefreshJournals();
        // Optionally switch back to active view to see the new reminder
        handleViewChange('entries');
    };

    return (
        <div className={`garden-manager-journal-section`}>
            {/* header for secondary buttons! */}
            <div className={`garden-manager-journals-section-header`}>
                <button
                    className={`garden-manager-journals-section-header-button ${currentView === 'entries' ? 'selected' : ''}`}
                    onClick={() => handleViewChange('entries')}
                >
                    Journals
                </button>
                <button
                    className={`garden-manager-journals-section-header-button ${currentView === 'add' ? 'selected' : ''}`}
                    onClick={() => handleViewChange('add')}
                >
                    Add New
                </button>
            </div>

            {/* section for showing all journal entries */}
            {currentView === 'entries' && (
                <div className={`garden-manager-entries-container`}>
                    {/* Garden specific journals */}
                    <div className={`garden-manager-garden-journal-entries`}>
                        <h3>Garden Journal Entries</h3>
                        {gardenSpecificJournals.length > 0 ? (
                            gardenSpecificJournals.map((journal) => (
                                <JournalEntryComponent key={journal.id} journalEntry={journal}/>
                            ))
                        ) : (
                            // <div className="garden-manager-empty-journal-section">
                            <div className="no-entries-message">
                                <p>No garden related journal entries</p>
                            </div>
                        )}
                    </div>

                    {/* Other journals */}
                    <div className={`garden-manager-other-journal-entries`}>
                        <h3>Other Journal Entries</h3>
                        {otherJournals.length > 0 ? (
                            otherJournals.map((journal) => (
                                <JournalEntryComponent key={journal.id} journalEntry={journal}/>
                            ))
                        ) : (
                            // <div className="garden-manager-empty-journal-section">
                            <div className="no-entries-message">
                                <p>No other journal entries</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* section for adding a journal */}
            {currentView === 'add' && (
                <div className={`garden-manager-add-journal-container`}>
                    <AddJournalComponent garden={garden} plants={garden.plants} journalRefresh={handleJournalRefresh}/>
                </div>
            )}
        </div>
    )
}

export default GardenManagerJournalComponent;